import React, { useState, useRef, useEffect } from "react";
import Modal from "../../../Modals/Modal";
import { MODAL_CLOSE, STORIES } from "src/constants/images";

const AddStoryModal = ({
  onClose,
  isVisible,
  handleCreateStory,
  setStoryContent,
  storyContent,
  storyContentIsConfirm,
  setStoryContentIsConfirm,
  gbetInWallet,
  ggInWallet,
  storyCost,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="storyModal addStory"
    >
      <div className="addStoryModalContainer">
        <div className="header">
          <h5>{!storyContentIsConfirm ? "Add Story" : "Confirm"}</h5>
          <div
            onClick={() => onClose()}
            onKeyPress={(e) => e.code == "Enter" && onClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </div>
        </div>
        <div className="addStoryModal-body">
          {!storyContentIsConfirm ? (
            <div className="info">
              <div className="left">
                <div className="infoBody">
                  {!storyContentIsConfirm ? (
                    <>
                      Stories are a collection of text that you can add to your
                      GangstaBet NFT. Stories can add a new dimension of
                      uniqueness, desirability & expression for your character.
                    </>
                  ) : (
                    <>
                      Once the story is added, it will be permanently written in
                      the Blockchain. Only the Owner can delete the story by{" "}
                      <span>Burning $GBET.</span>
                    </>
                  )}
                </div>
              </div>
              <div className="right">
                <div className="d-flex as-title">
                  <div style={{ color: "var( --add-story-text)" }}>Fees</div>
                  <span className="custom-tooltip">
                    <span className="tooltiptext">
                      $GBET used to write a story will be permanently burnt.
                    </span>
                    <img
                      src={STORIES.INFO}
                      alt="info"
                      style={{ filter: "var(--svg-change-color)" }}
                    />
                  </span>
                </div>
                <div className="d-flex as-fees">
                  <div style={{ color: "var( --add-story-text)" }}>
                    <span>{storyCost}</span> $GBET
                  </div>
                  <img src={STORIES.CHEST} alt="info" />
                  {/* <div>
               {" & "} <span>25</span> $GG{" "}
             </div>
             <img src={STORIES.FIRE} alt="info" /> */}
                </div>
              </div>
            </div>
          ) : null}
          {!storyContentIsConfirm ? (
            <textarea
              className="storyTextArea"
              disabled={storyContentIsConfirm}
              value={storyContent}
              style={{
                background: `${!storyContentIsConfirm ? "" : "#f3f3f3"}`,
              }}
              onChange={(e) => {
                setStoryContent(e.target.value);
              }}
            />
          ) : (
            <div className="grey-border featured-story profile-page-section-radius">
              <div className="feature-text">
                {storyContent.replace(/[&\/\\#$~%<>{}]/g, "")}
              </div>
            </div>
          )}

          {!storyContentIsConfirm ? (
            <div className="wallet-text-cap">
              <div
                className="infoWallet"
                style={{ color: "var( --add-story-text)" }}
              >
                You have <span>{gbetInWallet.toFixed(0)}</span> $GBET in your
                wallet.
              </div>
              <div className="characterLimit">
                {storyContent.length} / 500 Characters
              </div>
            </div>
          ) : null}
        </div>

        <div
          className="buttons-ctas"
          style={{
            marginTop: `${!storyContentIsConfirm ? "" : "24px"}`,
          }}
        >
          <button
            className="dark"
            disabled={
              storyContent.length == 0 || storyContent.length >= 501
                ? true
                : false
            }
            onClick={() => {
              if (storyContent.length >= 1 && storyContentIsConfirm) {
                handleCreateStory(storyContent);
              } else if (storyContent.length >= 1 && !storyContentIsConfirm) {
                setStoryContentIsConfirm(true);
              }
            }}
          >
            {!storyContentIsConfirm ? "Next" : "Confirm"}
          </button>
          <button
            className="ghost mx-2"
            onClick={() => {
              if (storyContentIsConfirm) {
                setStoryContentIsConfirm(false);
              } else {
                console.log("on close");
                onClose();
              }
            }}
          >
            {!storyContentIsConfirm ? "Cancel" : "Back"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddStoryModal;
